'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/tree-select/style/css');

var _treeSelect = require('antd/lib/tree-select');

var _treeSelect2 = _interopRequireDefault(_treeSelect);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _areas_small = require('../utils/areas_small');

var _areas_small2 = _interopRequireDefault(_areas_small);

var _currency_input = require('./currency_input');

var _currency_input2 = _interopRequireDefault(_currency_input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /**
                                                                                                                                                                                                     * 运费模版配送区域及运费设置组件
                                                                                                                                                                                                     */


var ShippingRegionInput = _react2.default.createClass({
    displayName: 'ShippingRegionInput',
    getInitialState: function getInitialState() {
        return {
            items: [{
                regions: []
            }]
        };
    },
    onAddItem: function onAddItem() {
        this.setState(function (state, props) {
            var items = [].concat(_toConsumableArray(state.items));
            items.push({
                regions: []
            });
            this.triggerChange({
                items: items
            });
            return {
                items: items
            };
        });
    },
    onDelItem: function onDelItem(index) {
        this.setState(function (state, props) {
            var items = [].concat(_toConsumableArray(state.items));
            items.splice(index, 1);
            this.triggerChange({
                items: items
            });
            return {
                items: items
            };
        });
    },
    onRegionChange: function onRegionChange(index, value) {
        this.setState(function (state, props) {
            var items = [].concat(_toConsumableArray(state.items));
            items[index].regions = value;
            this.triggerChange({
                items: items
            });
            return {
                items: items
            };
        });
    },
    onNumberChange: function onNumberChange(index, type, event) {
        var value = event.target.value;
        this.setState(function (state, props) {
            var items = [].concat(_toConsumableArray(state.items));
            switch (type) {
                case 0:
                    items[index].firstHeavy = value;break;
                case 1:
                    items[index].firstPrice = value;break;
                case 2:
                    items[index].forwardingHeavy = value;break;
                case 3:
                    items[index].forwardingPrice = value;break;
            }
            this.triggerChange({
                items: items
            });
            return {
                items: items
            };
        });
    },
    triggerChange: function triggerChange(changedValue) {
        // Should provide an event to pass value to Form.
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(Object.assign({}, this.state, changedValue));
        }
    },
    render: function render() {
        var _this = this;

        var items = this.state.items;

        var tProps = {
            treeData: _areas_small2.default.map(function (item) {
                delete item.children.children;return item;
            }),
            placeholder: '请选择配送区域',
            multiple: true,
            treeCheckable: true,
            showCheckedStrategy: _treeSelect2.default.SHOW_PARENT,
            searchPlaceholder: 'Please select',
            style: {
                width: 300
            }
        };
        var style = {
            width: '6em',
            display: 'inline-block',
            position: 'relative',
            top: 10,
            margin: '0 5px'
        };
        return _react2.default.createElement(
            'div',
            null,
            items.map(function (item, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(_treeSelect2.default, _extends({}, tProps, { value: item.regions, onChange: _this.onRegionChange.bind(null, index) })),
                    _react2.default.createElement(
                        'div',
                        { style: style },
                        _react2.default.createElement(_currency_input2.default, { value: item.firstHeavy, onChange: _this.onNumberChange.bind(null, index, 0), placeholder: '\u9996\u91CD', addonBefore: '', addonAfter: 'kg' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: style },
                        _react2.default.createElement(_currency_input2.default, { value: item.firstPrice, onChange: _this.onNumberChange.bind(null, index, 1), placeholder: '\u8FD0\u8D39', addonBefore: '', addonAfter: '\u5143' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: style },
                        _react2.default.createElement(_currency_input2.default, { value: item.forwardingHeavy, onChange: _this.onNumberChange.bind(null, index, 2), placeholder: '\u7EED\u91CD', addonBefore: '', addonAfter: 'kg' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { style: style },
                        _react2.default.createElement(_currency_input2.default, { value: item.forwardingPrice, onChange: _this.onNumberChange.bind(null, index, 3), placeholder: '\u8FD0\u8D39', addonBefore: '', addonAfter: '\u5143' })
                    ),
                    _react2.default.createElement(
                        _button2.default,
                        { type: 'primary', onClick: _this.onDelItem.bind(null, index) },
                        '\u5220\u9664'
                    )
                );
            }),
            _react2.default.createElement(
                _button2.default,
                { onClick: this.onAddItem },
                '\u6DFB\u52A0\u914D\u9001\u533A\u57DF\u53CA\u8FD0\u8D39'
            )
        );
    }
});

exports.default = ShippingRegionInput;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/shipping_region_input.js
// module id = 1530
// module chunks = 0